/**
 * Interaction blocker for PLP and Search pages.
 * Blocks/unblocks user interaction during async operations (filter, sort, pagination).
 * @param {boolean} block - true to block, false/undefined to unblock
 */
const PLACEHOLDER_SELECTOR = '.plp-c-results__placeholder-card';

const selectors = [
  '.plp-c-results__list',
  '.sidebar-c-basis',
  '.plp-c-pagination__wrapper',
  '.plp-c-results-header__pod--desktop',
  '.plp-c-results-header__pod--mobile',
  '.plp-c-mobile-sort-modal',
  '.plp-c-mobile-filter-modal',
];

function hideLoader() {
  document.querySelectorAll(PLACEHOLDER_SELECTOR).forEach((el) => el.remove());
}

export default function (block = false) {
  const method = block ? 'add' : 'remove';
  selectors.forEach((selector) => document.querySelectorAll(selector).forEach((el) => el.classList[method]('blocked')));

  const resultsList = document.querySelector('.plp-c-results__list');
  if (resultsList) resultsList.setAttribute('aria-busy', block ? 'true' : 'false');

  if (!block) hideLoader();
}
